import React, { useState } from 'react'
import { Button, message, Typography, Input, Space, Divider, List } from 'antd'
import { CloudUploadOutlined, FolderOpenOutlined, HistoryOutlined } from '@ant-design/icons'
import { backend } from '../../api'
import api from '../../api'

const { Title, Text, Paragraph } = Typography

export default function DataBackup() {
  const [loading, setLoading] = useState(false)
  const [backupPath, setBackupPath] = useState('')
  const [targetDir, setTargetDir] = useState('')
  const [history, setHistory] = useState([])

  const handleSelectDir = async () => {
    try {
      const result = await api.selectDirectory()
      if (!result.canceled && result.path) {
        setTargetDir(result.path)
      }
    } catch (err) {
      message.error('选择目录失败: ' + (err.message || '未知错误'))
    }
  }

  const handleCreateBackup = async () => {
    setLoading(true)
    try {
      const res = await backend.createBackup(targetDir || '')
      if (res.success || res.filepath) {
        const fp = res.filepath || res.data?.filepath || ''
        setBackupPath(fp)
        setHistory(prev => [fp, ...prev].slice(0, 10))
        message.success('备份创建成功')
      } else {
        message.error(res.message || '备份失败')
      }
    } catch (err) {
      message.error('备份请求失败: ' + (err.message || '未知错误'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <Title level={4}>数据备份</Title>
      <Paragraph type="secondary">备份数据库到本地文件，请先选择保存路径</Paragraph>

      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <Input
            value={targetDir}
            readOnly
            placeholder="未选择备份路径"
            style={{ flex: 1 }}
            prefix={<FolderOpenOutlined />}
          />
          <Button icon={<FolderOpenOutlined />} onClick={handleSelectDir}>
            选择路径
          </Button>
        </div>

        <Button
          type="primary"
          size="large"
          icon={<CloudUploadOutlined />}
          loading={loading}
          onClick={handleCreateBackup}
          block
        >
          创建备份
        </Button>
      </Space>

      {backupPath && (
        <div style={{ marginTop: 16 }}>
          <Text type="success">最近备份: {backupPath}</Text>
        </div>
      )}

      {history.length > 0 && (
        <>
          <Divider />
          <Text strong><HistoryOutlined /> 备份历史</Text>
          <List
            size="small"
            dataSource={history}
            style={{ marginTop: 8 }}
            renderItem={item => (
              <List.Item>
                <Text code style={{ fontSize: 12 }}>{item}</Text>
              </List.Item>
            )}
          />
        </>
      )}
    </div>
  )
}
